import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyEuro: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCurrencyEuro"><Path d="M2.5 10.5H12.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M2.5 13.5H12.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M19.5 5.87807C17.9408 3.81224 15.6075 2.5 13 2.5C8.30558 2.5 4.5 6.75329 4.5 12C4.5 17.2467 8.30558 21.5 13 21.5C15.6075 21.5 17.9408 20.1878 19.5 18.1219" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCurrencyEuro;
